import { Icon, Spinner, useScrollLock } from '../../ui'
import styles from './CreatePage.module.css'

export function GenerateOverlay({ activeStep, steps }: { activeStep: number; steps: { label: string; detail: string }[] }) {
  useScrollLock(true)
  return (
    <div className={styles.overlay} data-scope="state-generating" role="dialog" aria-modal="true" aria-label="正在生成投放方案">
      <div className={styles.generateCard}>
        <h4>正在生成投放方案</h4>
        {steps.map((step, index) => (
          <div key={step.label} className={`${styles.generateStep} ${index < activeStep ? styles.done : ''} ${index === activeStep ? styles.now : ''}`}>
            {index < activeStep ? <span className={styles.doneIcon}><Icon name="check-circle" size={18} strokeWidth={2} /></span> : index === activeStep ? <Spinner /> : <span className={styles.stepDot} />}
            <div><b>{step.label}</b>{index <= activeStep ? <p>{step.detail}</p> : null}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
